/* eslint-disable*/
import gql from 'graphql-tag'

const query_posts = 
    gql`query user_posts{
        user_posts {
          post_id
          post_url
          post_date
          user_id
        }
      }`


export default query_posts;